

















































import {mixins} from "vue-class-component";
import {Component} from "vue-property-decorator";
import {CommonMixin} from "@/shared/services/mixin";
import {CountryStore} from "@/modules/regionsv2/country/store";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import CountrySearch from "@/modules/regionsv2/country/components/Search/index.vue";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import CountryAction from "@/modules/regionsv2/country/components/Action/index.vue";
import CountryForm from "@/modules/regionsv2/country/Form/index.vue";

const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 20
    },
    {
        title: 'Mã nước',
        dataIndex: 'code',
        key: 'code',
        scopedSlots: { customRender: 'code' },
        width: 100
    },
    {
        title: 'Tên nước',
        dataIndex: 'name',
        key: 'name',
        scopedSlots: { customRender: 'name' },
        width: 100
    },
    {
        title: 'Trạng thái',
        dataIndex: 'status',
        key: 'status',
        scopedSlots: { customRender: 'status' },
        width: 100
    },
    {
        title: 'Thao tác',
        dataIndex: 'id',
        key: 'action',
        scopedSlots: { customRender: 'action' },
        width: 50
    }
]
@Component({
    name: "CountryList",
    components: {CountryForm, CountryAction, EnumSelector, CommonStatusLabel, CountrySearch}
})
export default class extends mixins(CommonMixin) {
    columns = columns;
    CommonStatus = CommonStatus;

    get dataSource() {
        return CountryStore.countries;
    }

    get pagination() {
        return {
            current: CountryStore.meta.page,
            pageSize: CountryStore.meta.limit,
            total: CountryStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} nước`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        CountryStore.paramsChangeV2({...CountryStore.params, page: pagination.current, limit: pagination.pageSize});
    }
}
